import gql from 'graphql-tag';

export const GET_SUBSCRIPTION_DETAILS = gql`
    query getSubDetails($studentId: Int!) {
        subscriptions(where: {student_id: {_eq: $studentId}}, order_by: [{created_at: desc}]) {
            id
            cancelled_at
            contract_filename
            end_date
            installment_amount
            installments
            signup_fee
            start_date
            status
            stripe_customer_id
            stripe_subscription_id
            total
            plan_id
            product {
                id
                package_name
                pricing_model
                product_type
            }
        }
    }
`